import * as React from "react";
import { useTranslation } from "hhn-commons";
import {
  AboutInputField,
  FormControlLayout,
  WordLimit,
} from "./AddPatientGroup.style";

type AboutFieldProps = {
  about: string;
  onSetAbout: (about: string) => void;
};
export const AboutField = ({ about = "", onSetAbout }: AboutFieldProps) => {
  const { t } = useTranslation();
  const tNs = (key: string): string => t(key, { ns: "groupChatInfo" });
  return (
    <FormControlLayout>
      <AboutInputField
        id="about"
        label={tNs("about")}
        type="text"
        variant="standard"
        value={about}
        multiline
        rows={3}
        onChange={e => {
          onSetAbout(e.target.value);
        }}
        slotProps={{
          htmlInput: {
            "data-testid": "about-patient",
            maxLength: 3000,
          },
        }}
      />
      <WordLimit>{about ? about.length : 0}/3000</WordLimit>
    </FormControlLayout>
  );
};
